document.addEventListener('DOMContentLoaded', function() {
  const swipers = document.querySelectorAll('.testimonials-swiper');
  if (!swipers.length) return;

  swipers.forEach((testimonialsSection) => {
    const sectionId = testimonialsSection.dataset.sectionId;
    const autoRotate = testimonialsSection.dataset.autoRotate === 'true';
    const rotateSpeed = (parseInt(testimonialsSection.dataset.rotateSpeed, 10) || 5) * 1000;
    const transitionEffect = testimonialsSection.dataset.transitionEffect || 'slide';
    const animationEnabled = testimonialsSection.dataset.animationEnabled === 'true';

    testimonialsSection.classList.add(transitionEffect === 'fade' ? 'fade-effect' : 'slide-effect');
    if (animationEnabled) testimonialsSection.classList.add('animation-enabled');

    const swiperConfig = {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      centeredSlides: true,

      navigation: {
        nextEl: `#testimonials-next-${sectionId}`,
        prevEl: `#testimonials-prev-${sectionId}`,
      },

      pagination: {
        el: `#testimonials-pagination-${sectionId}`,
        clickable: true,
      },

      effect: transitionEffect,
      ...(transitionEffect === 'fade'
        ? { fadeEffect: { crossFade: true } }
        : { speed: 600, slidesPerGroup: 1 }),

      ...(autoRotate ? {
        autoplay: { delay: rotateSpeed, disableOnInteraction: false, pauseOnMouseEnter: true }
      } : {}),

      on: {
        init() {
          if (animationEnabled) {
            const activeSlide = this.slides[this.activeIndex];
            activeSlide?.querySelectorAll('.testimonial-content > *')
              .forEach(el => { el.style.opacity = '0'; });
          }

          const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (entry.isIntersecting && animationEnabled) {
                const activeSlide = this.slides[this.activeIndex];
                activeSlide?.querySelectorAll('.testimonial-content > *')
                  .forEach(el => { el.style.opacity = ''; });
                observer.unobserve(entry.target);
              }
            });
          }, { threshold: 0.3 });
          observer.observe(this.el);
        }
      }
    };

    const swiper = new Swiper(testimonialsSection, swiperConfig);

    // Acessibilidade
    const updateAriaLabels = () => {
      const current = (swiper.realIndex ?? 0) + 1;
      const total = swiper.slides.length - (swiper.params.loop ? swiper.loopedSlides * 2 : 0);
      testimonialsSection.setAttribute('aria-label', `Depoimento ${current} de ${total}`);
    };
    swiper.on('slideChange', updateAriaLabels);
    updateAriaLabels();

    // Interações que pausam autoplay
    if (autoRotate) {
      const pause = () => swiper.autoplay.stop();
      const resume = () => swiper.autoplay.start();
      testimonialsSection.addEventListener('mouseenter', pause);
      testimonialsSection.addEventListener('mouseleave', resume);
      testimonialsSection.querySelectorAll('button, a').forEach(el => {
        el.addEventListener('focus', pause);
        el.addEventListener('blur', resume);
      });
    }

    // Teclado
    testimonialsSection.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') swiper.slidePrev();
      if (e.key === 'ArrowRight') swiper.slideNext();
    });

    // Recalcular em resize
    let resizeTimeout;
    const adjust = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        swiper.update();
      }, 200);
    };
    window.addEventListener('resize', adjust);
  });
});
